/* eslint-disable no-unused-vars */
const THREE = window.THREE;
import store from '@/store'
import {
	ForgeEquipment,
	ForgeAnnotation,
	ForgeInspection,
	ForgeScaffold,
	ForgeAttachment,
	UserSettings,
	DisplaySettings,
	PointCloudDisplay,
	PointCloudDownload,
	ForgePageMarkup,
	ForgeCamera,
	PointCloudModelInfo,
	ForgeLevel,
	ForgeModelVersion,
	ForgePipeline,
	ForgeStructural
} from './../scripts/js/forgeModels';
import HttpService from './httpService';

export const editType = {
	CHANGE_LEVEL: "ChangeLevel",

	CREATE_TAG: "CreateTag",
	EDIT_TAG: "EditTag",
	DELETE_TAGS: "DeleteTag",

	CREATE_LEVEL: "CreateLevel",
	EDIT_LEVEL: "EditLevel",
	DELETE_LEVEL: "DeleteLevel",

	CREATE_PID: "CreatePID",
	EDIT_PID: "EditPID",
	DELETE_PID: "DeletePID",

	CREATE_Project: "CreateProject",
	EDIT_Project: "EditProject",
	DELETE_Project: "DeleteProject",

	EDIT_IMAGE360: "EditImage360",
	DELETE_IMAGES360: "DeleteImages360",

	CREATE_ANNOTATION: "CreateAnnotation",
	EDIT_ANNOTATION: "EditAnnotation",
	DELETE_ANNOTATIONS: "DeleteAnnotations",

	CREATE_AMIS: "CreateAMIS",
	EDIT_AMIS: "EditAMIS",
	DELETE_AMIS: "DeleteAMIS",

	CREATE_INSPECTION: "CreateInspection",
	EDIT_INSPECTION: "EditInspection",
	DELETE_INSPECTION: "DeleteInspection",

	CREATE_SCAFFOLD: "CreateScaffold",
	EDIT_SCAFFOLD: "EditScaffold",
	DELETE_SCAFFOLDS: "DeleteScaffolds",

	CREATE_CAMERA: "CreateCamera",
	DELETE_CAMERAS: "DeleteCameras",
}

export function saveTags(obj, changeType, img64, callback) {
	switch (changeType) {
		case editType.CREATE_TAG:
			postDataAsync('api/equipments/createEquipment', { 'assetId': store.state.assetId, 'tag': obj, 'img64': img64 }, tag => {
				obj.id = tag.id;
				obj.thumbnailUrl = tag.thumbnailUrl;
				//update ids for childs coming from server
				tag.children.forEach(o => {
					var existingChild = obj.children.find(e => e.dbId == o.dbId);
					if (existingChild)
						existingChild.id = o.id;
				})
				if (callback)
					callback();
			});
			break;
		case editType.EDIT_TAG:
			postDataAsync('api/equipments/editEquipment', { 'assetId': store.state.assetId, 'tag': obj, 'img64': img64 }, tag => {
				tag = Object.assign(new ForgeEquipment(), tag)
				tag.parseContent();
				obj.setSameParameters(tag);
				if (callback)
					callback();
			});
			break;
		case editType.DELETE_TAGS:
			postDataAsync('api/equipments/deleteEquipment', { 'assetId': store.state.assetId, 'tagsGuid': obj.map(o => o.id) }, () => {
				if (callback)
					callback();
			});
			break;
	}
}
export function saveLevels(obj, changeType, callback) {
	switch (changeType) {
		case editType.CHANGE_LEVEL:
			postDataAsync('api/levels/editLevels', { 'assetId': store.state.assetId, 'levels': store.state.levels });
			break;
		case editType.CREATE_LEVEL:
			postDataAsync('api/levels/createLevel', { 'assetId': store.state.assetId, 'level': obj }, id => {
				obj.id = id;
				if (callback) callback(id);
			});
			break;
		case editType.EDIT_LEVEL:
			postDataAsync('api/levels/editLevel', { 'assetId': store.state.assetId, 'level': obj });
			break;
		case editType.DELETE_LEVEL:
			postDataAsync(`api/levels/deleteLevel?id=${obj.id}&assetId=${store.state.assetId}`, null);
			break;

	}
}
export function savePIDs(obj, changeType) {
	switch (changeType) {
		case editType.CREATE_PID:
			postDataAsync('api/pdis/createPid', { 'assetId': store.state.assetId, 'pid': obj }, id => {
				obj.id = id;
			});
			break;
		case editType.EDIT_PID:
			postDataAsync('api/pids/editPId', { 'assetId': store.state.assetId, 'pid': obj });
			break;
		case editType.DELETE_PID:
			postDataAsync(`api/pids/delete?id=${obj.id}`, null);
			break;
	}
}
export function saveProjects(obj, changeType, args1) {
	switch (changeType) {
		case editType.CREATE_Project:
			postDataAsync('api/forge/projects/createproject', { 'assetId': store.state.assetId, 'project': obj }, id => {
				obj.id = id;
			});
			break;
		case editType.EDIT_Project:
			postDataAsync('api/forge/projects/editproject', { 'assetId': store.state.assetId, 'project': obj });
			break;
		case editType.DELETE_Project:
			postDataAsync('api/forge/projects/deleteproject?id=' + obj.id, null);
			break;

		case editType.EDIT_IMAGE360:
			postDataAsync('api/images360/editImage360', { 'assetId': store.state.assetId, 'image': obj, 'levelName': args1 });
			break;
		case editType.DELETE_IMAGES360:
			postDataAsync('api/images360/deleteImages360', { 'assetId': store.state.assetId, 'ids': obj.map(o => o.id) });
			break;

	}
}
export function saveAnnotations(obj, changeType, img64, callback, onError) {
	switch (changeType) {
		case editType.CREATE_ANNOTATION:
			postDataAsync(
				'api/annotations/createAnnotation',
				{ 'assetId': store.state.assetId, 'annotation': obj, 'img64': img64 },
				anno => {
					obj.id = anno.id;
					obj.thumbnailUrl = anno.thumbnailUrl;
					//update ids for childs coming from server
					anno.children.forEach(o => {
						var existingChild = obj.children.find(e => e.dbId == o.dbId);
						if (existingChild)
							existingChild.id = o.id;
					})

					if (callback) callback();
				},
				error => {
					if (onError) onError(error);
				}
			);
			break;
		case editType.EDIT_ANNOTATION:
			postDataAsync(
				'api/annotations/editAnnotation',
				{ 'assetId': store.state.assetId, 'annotation': obj, 'img64': img64 },
				anno => {
					anno = Object.assign(new ForgeAnnotation(), anno)
					anno.parseContent();
					obj.setSameParameters(anno);
					if (callback) callback();
				},
				error => {
					if (onError) onError(error);
				}
			);
			break;
		case editType.DELETE_ANNOTATIONS:
			postDataAsync(
				'api/annotations/deleteAnnotations',
				{ 'assetId': store.state.assetId, 'guids': obj.map(o => o.id) },
				() => {
					if (callback) callback();
				},
				error => {
					if (onError) onError(error);
				}
			);
			break;
	}
}
export function saveAMIS(obj, changeType, img64, callback, onError) {
	switch (changeType) {
		case editType.CREATE_AMIS:
			postDataAsync('api/AMIS/create', { 'assetId': store.state.assetId, 'inspection': obj, 'img64': img64 }, anno => {
				obj.id = anno.id;
				obj.thumbnailUrl = anno.thumbnailUrl;
				//update ids for childs coming from server
				anno.children.forEach(o => {
					var existingChild = obj.children.find(e => e.dbId == o.dbId);
					if (existingChild)
						existingChild.id = o.id;
				})
				if (callback)
					callback();
			}, onError);
			break;
		case editType.EDIT_AMIS:
			postDataAsync('api/AMIS/edit', { 'assetId': store.state.assetId, 'inspection': obj, 'img64': img64 }, anno => {
				anno = Object.assign(new ForgeInspection(), anno)
				anno.parseContent();
				obj.setSameParameters(anno);
				if (callback)
					callback();
			});
			break;
		case editType.DELETE_AMIS:
			postDataAsync('api/AMIS/delete', { 'assetId': store.state.assetId, 'guids': obj.map(o => o.id) }, () => {
				if (callback)
					callback();
			});
			break;
	}
}
export function saveInspections(obj, changeType, img64, callback) {
	switch (changeType) {
		case editType.CREATE_INSPECTION:
			postDataAsync('api/forge/inspections/createInspection', { 'assetId': store.state.assetId, 'inspection': obj, 'img64': img64 }, anno => {
				obj.id = anno.id;
				obj.thumbnailUrl = anno.thumbnailUrl;
				if (callback)
					callback();
			});
			break;
		case editType.EDIT_INSPECTION:
			postDataAsync('api/forge/inspections/editInspection', { 'assetId': store.state.assetId, 'inspection': obj, 'img64': img64 }, anno => {
				anno = Object.assign(new ForgeInspection(), anno)
				anno.parseContent();
				obj.setSameParameters(anno);
				if (callback)
					callback();
			});
			break;
		case editType.DELETE_INSPECTION:
			postDataAsync('api/forge/inspections/deleteInspections', { 'assetId': store.state.assetId, 'guids': obj.map(o => o.id) }, () => {
				if (callback)
					callback();
			});
			break;
	}
}
export function saveCamera(obj, changeType, arg, callback) {
	switch (changeType) {
		case editType.CREATE_CAMERA:
			postDataAsync('api/forge/dashboard/createCamera', { 'assetId': store.state.assetId, 'camera': obj, 'thumbnailBase64': arg }, callback, "application/json; charset=utf8");
			break;
		case editType.DELETE_CAMERAS:
			postDataAsync('api/forge/dashboard/deleteCamera', { 'assetId': store.state.assetId, 'cameraGuids': obj.map(o => o.id) }, callback);
			break;
	}
}
export function saveScaffolds(obj, changeType, img64, callback) {
	switch (changeType) {
		case editType.CREATE_SCAFFOLD:
			postDataAsync('api/scaffolds/createScaffold', { 'assetId': store.state.assetId, 'scaffold': obj, 'img64': img64 }, scaffold => {
				obj.id = scaffold.id;
				obj.thumbnailUrl = scaffold.thumbnailUrl;
				if (callback)
					callback();
			});
			break;
		case editType.EDIT_SCAFFOLD:
			postDataAsync('api/scaffolds/editScaffold', { 'assetId': store.state.assetId, 'scaffold': obj, 'img64': img64 }, scaffold => {
				obj.thumbnailUrl = scaffold.thumbnailUrl;
				if (callback)
					callback();
			});
			break;
		case editType.DELETE_SCAFFOLDS:
			postDataAsync('api/scaffolds/deleteScaffolds', { 'assetId': store.state.assetId, 'guids': obj.map(o => o.id) });
			break;
	}
}
export function saveTagCategory(name, color) {
	var info = {
		assetId: store.state.assetId,
		name: name,
		color: color
	};
	postData('api/categories/editCategories', info);
}
export function saveState(state, callBack) {
	var info = {
		state: JSON.stringify(state)
	};
	postData('api/states/addState', info, id => {
		callBack(id)
	});
}
export function fetchState(id, callback) {
	HttpService.get({
		url: `api/states/getState?id=${id}`,
	}).then(response => {
		var state = !response.data ? null : JSON.parse(response.data.state);
		callback(state);
	}).catch(error => {
		console.log(error)
		callback(null);
	});
}
export function getTagsAnnotationsScaffolds() {
	HttpService.get({
		url: `api/getTagsAnnotationsScaffolds`,
		params: {
			assetId: store.state.assetId
		},
	}).then(response => {
		console.log(response.data);
	}).catch(error => {
		console.log(error)
	})
}

export function postData(url, data, onSuccess, onError, onFinally, contentType = 'application/json') {
	forgePost(url, data, false, onSuccess, onError, onFinally, contentType)
}
export function postDataAsync(url, data, onSuccess, onError, onFinally, contentType = 'application/json') {
	forgePost(url, data, true, onSuccess, onError, onFinally, contentType)
}
export function forgePost(url, data, async, onSuccess, onError, onFinally, contentType = 'application/json') {
	HttpService.post({
		url: url,
		data: data,
		headers: {
			contentType: contentType
		}
	}).then(response => {
		if (onSuccess)
			onSuccess(response.data);
	}).catch(error => {
		if (onError)
			onError(error);
	}).finally((e) => {
		if (onFinally)
			onFinally(e);
	})
}
export function forgeFetch(url, callback) {
	HttpService.get({
		url: url,
	}).then(response => {
		callback(response.data);
	}).catch(error => {
		console.log(error)
		callback(null);
	});
}
export function mongoToSql() {
	HttpService.post({
		url: `api/mongoToSql/translate`,
	}).then(response => {
		console.log(response.data);
	}).catch(error => {
		console.log(error);
	});
}
export function fetchProjectModelsInfo(assetId, callback) {
	HttpService.get({
		url: `api/forge/projects/getProjectModelsInfo`,
		params: {
			assetId: assetId
		}
	}).then(response => {
		var models = response.data;
		if (models == null)
			return;
		callback(models);
	}).catch(error => {
		console.log(error)
	})

}
export function fetchUserSettings(userId) {
	HttpService.get({
		url: `api/forge/settings/getUserSettings`,
		params: {
			userId: userId
		}
	}).then(response => {
		let settings = response.data;

		if (!settings) {
			store.state.userSettings = new UserSettings();
			store.state.userSettings.id = userId;
			return;
		}

		settings = Object.assign(new UserSettings(), settings);

		if (settings.displaySettings) {
			settings.displaySettings = Object.assign(new DisplaySettings(), settings.displaySettings);
			if (settings.displaySettings.pointCloudDisplay) {
				settings.displaySettings.pointCloudDisplay = Object.assign(new PointCloudDisplay(), settings.displaySettings.pointCloudDisplay);
			} else {
				settings.displaySettings.pointCloudDisplay = new PointCloudDisplay();
			}
		}
		else {
			settings.displaySettings = new DisplaySettings();
		}

		settings.displaySettings.renderFPS = localStorage.getItem(DisplaySettings.fpsLocalStorageKey) ?? 8;

		settings.id = userId
		store.state.userSettings = settings;
	}).catch(error => {
		console.log(error)
		store.state.userSettings = new UserSettings();
		store.state.userSettings.id = userId;
	});
}
export function testTranslateDataInAzure() {
	HttpService.post({
		url: `api/forge/azure/translateData`,
	}).then(response => {
		console.log(response.data);
	}).catch(error => {
		console.log(error);
	});
}
export function deletePointCloud() {
	HttpService.post({
		url: `api/forge/azure/deletePointCloud`,
	}).then(response => {
		console.log(response.data);
	}).catch(error => {
		console.log(error);
	})
}

export async function getJSON(url) {
	return await HttpService.get({
		url: url,
	}).then(response => {
		return response.data;
	}).catch(error => {
		console.log(error)
		return null;
	})
}

//Stamps
export async function getAllMarkupStamps() {
	var url = 'api/forge/stamps/getMarkupStamps';
	return await getJSON(url);
}

export function saveMarkupStamp(stamp) {
	var url = 'api/forge/stamps/saveMakrupStamp';
	postData(url, stamp);
}

export function deleteMarkupStamp(stamp) {
	var url = `api/forge/stamps/deleteMarkupStamp/${stamp.id}`;
	HttpService.delete({
		url: url,
	});
}

//Symbols
export async function getAllMarkupSymbols() {
	var url = 'api/forge/symbols/getMarkupSymbols';
	return await getJSON(url);
}

export function saveMarkupSymbol(symbol) {
	var url = 'api/forge/symbols/saveMakrupSymbol';
	var savedSymbol = null;
	postData(url, symbol, (res) => {
		savedSymbol = res;
	});
	return savedSymbol;
}

export function deleteMarkupSymbol(symbol) {
	var url = `api/forge/symbols/deleteMarkupSymbol/${symbol.id}`;
	HttpService.delete({
		url: url,
	});
}

//ForgeAttachment
export async function getAttachment(id) {
	var url = `api/forge/attachments/getAttachment/${id}`;
	var attachmentJson = await getJSON(url);
	var attachment = Object.assign(new ForgeAttachment(), attachmentJson)

	if (!attachment.pagesMarkups)
		attachment.pagesMarkups = [];
	attachment.pagesMarkups = attachment.pagesMarkups.map(e => Object.assign(new ForgePageMarkup(), e));
	attachment.pagesMarkups.forEach(m => {
		if (m.cropBox)
			m.cropBox = Object.assign(new THREE.Box3(m.cropBox.min, m.cropBox.max));
	})
	return attachment;
}

export async function getAttachmentByReference(referenceDocumentId, referenceContextId, documentContentId) {
	var url = `api/forge/attachments/getAttachmentByReference/${referenceDocumentId}/${referenceContextId}/${documentContentId}`;
	var attachmentJson = await getJSON(url);
	var attachment = Object.assign(new ForgeAttachment(), attachmentJson)

	if (!attachment.pagesMarkups)
		attachment.pagesMarkups = [];
	attachment.pagesMarkups = attachment.pagesMarkups.map(e => Object.assign(new ForgePageMarkup(), e));
	attachment.pagesMarkups.forEach(m => {
		if (m.cropBox)
			m.cropBox = Object.assign(new THREE.Box3(m.cropBox.min, m.cropBox.max));
	})
	return attachment;
}

export async function getAttachmentsByReference(referenceDocumentIds, referenceContextId) {
	var query = "referenceDocumentIds=" + referenceDocumentIds.join("&referenceDocumentIds=");
	var url = `api/forge/attachments/getAttachmentsByReference?${query}&referenceContextId=${referenceContextId}`;
	var attachmentsJson = await getJSON(url);
	var attachments = [];
	if (attachmentsJson && attachmentsJson.length > 0) {
		for (let i = 0; i < attachmentsJson.length; i++) {
			const attachmentJson = attachmentsJson[i];
			var attachment = Object.assign(new ForgeAttachment(), attachmentJson)
			if (!attachment.pagesMarkups)
				attachment.pagesMarkups = [];
			attachment.pagesMarkups = attachment.pagesMarkups.map(e => Object.assign(new ForgePageMarkup(), e));
			attachment.pagesMarkups.forEach(m => {
				if (m.cropBox)
					m.cropBox = Object.assign(new THREE.Box3(m.cropBox.min, m.cropBox.max));
			})
			attachments.push(attachment);
		}
	}
	return attachments;
}

export async function getAttachments(ids) {
	var query = "ids=" + ids.join("&ids=");
	var url = `api/forge/attachments/getAttachments?${query}`;
	var attachmentsJson = await getJSON(url);
	var attachments = [];
	if (attachmentsJson && attachmentsJson.length > 0) {
		for (let i = 0; i < attachmentsJson.length; i++) {
			const attachmentJson = attachmentsJson[i];
			var attachment = Object.assign(new ForgeAttachment(), attachmentJson)
			if (!attachment.pagesMarkups)
				attachment.pagesMarkups = [];
			attachment.pagesMarkups = attachment.pagesMarkups.map(e => Object.assign(new ForgePageMarkup(), e));
			attachment.pagesMarkups.forEach(m => {
				if (m.cropBox)
					m.cropBox = Object.assign(new THREE.Box3(m.cropBox.min, m.cropBox.max));
			})
			attachments.push(attachment);
		}
	}
	return attachments;
}

export function postAttachment(attachment, callback) {
	var url = `api/forge/attachments/addAttachment`;
	postData(url, attachment, callback);
	return attachment;
}

export function editAttachment(attachment) {
	var url = `api/forge/attachments/editAttachment`;
	var result = false;
	HttpService.put({
		url: url,
		data: attachment,
	}).then(response => {
		result = attachment;
	});
	return result;
}

export function deleteAttachment(id) {
	var url = `api/forge/attachments/deleteAttachment/${id}`;
	var response = false;
	HttpService.delete({
		url: url,
	}).then(() => {
		response = true;
	});
	return response;
}

export function fetchAssetModel(assetId) {
	return new Promise((resolve, reject) => {
		forgeFetch(`api/assets/fetchForgeModel?assetId=${assetId}`, model => {
			resolve(model);
		})
	});
}

export function fetchAssetBookmarks(assetId) {
	return new Promise((resolve, reject) => {
		forgeFetch(`api/forge/dashboard/getAllBookmarks?assetId=${assetId}`, (bookmarks) => {
			bookmarks ??= [];
			let cameras = bookmarks.map(o => Object.assign(new ForgeCamera(), o));
			resolve(cameras);
		})
	});
}

export function fetchAssetModels(assetId, selectedModel) {
	return new Promise((resolve, reject) => {
		forgeFetch(`api/forge/models/getAssetSmallModels?assetId=${assetId}`, (models) => {
			models ??= [];
			let assetModels = models.filter(m => m.name !== selectedModel).map(o => Object.assign(new ForgeModelVersion(), o));
			resolve(assetModels);
		})
	});
}

export function fetchAssetPointCloudModels(assetId) {
	return new Promise((resolve, reject) => {
		forgeFetch(`api/forge/pointCloud/getAllPointCloudModels?assetId=${assetId}`, (models) => {
			models ??= [];
			var pointClouds = models.map(o => Object.assign(new PointCloudModelInfo(), o));
			resolve(pointClouds);
		})
	});
}

export function fetchAssetPointCloudDownloads(assetId) {
	return new Promise((resolve, reject) => {
		forgeFetch(`api/pointClouds/getAllPointCloudDownload?assetId=${assetId}`, (pcs) => {
			pcs ??= [];
			let result = pcs.map(o => Object.assign(new PointCloudDownload(), o));
			resolve(result);
		})
	});
}

export function fetchAssetCategories(assetId) {
	return new Promise((resolve, reject) => {
		forgeFetch(`api/forge/categories/getAllCategories?assetId=${assetId}`, (categories) => {
			categories ??= [];
			resolve(categories);
		})
	});
}

export function fetchAssetLevels(assetId) {
	return new Promise((resolve, reject) => {
		forgeFetch(`api/levels/getAllAssetLevels?assetId=${assetId}`, (levels) => {
			levels ??= [];
			let assetLevels = ForgeLevel.parseLevelsFromDB(levels);
			resolve(assetLevels);
		})
	});
}

export function fetchAssetProjects(assetId) {
	return new Promise((resolve, reject) => {
		forgeFetch(`api/forge/projects/getAssetProjects?assetId=${assetId}`, (projects) => {
			projects ??= [];
			resolve(projects);
		})
	});
}

export function fetchAssetNormalEquipment(assetId) {
	return new Promise((resolve, reject) => {
		forgeFetch(`api/equipments/getAllNormalEquipment?assetId=${assetId}`, (equipments) => {
			equipments ??= [];
			let tags = equipments.map(o => Object.assign(new ForgeEquipment(), o));
			tags.forEach(o => o.parseContent());
			resolve(tags);
		})
	});
}

export function fetchAssetManualPipelines(assetId) {
	return new Promise((resolve, reject) => {
		forgeFetch(`api/tags/pipeline/getAllManualPipelines?assetId=${assetId}`, (pipelines) => {
			pipelines ??= [];
			let tags = pipelines.map(o => Object.assign(new ForgePipeline(), o));
			tags.forEach(o => o.parseContent());
			resolve(tags);
		})
	});
}

export function fetchAssetManualStructural(assetId) {
	return new Promise((resolve, reject) => {
		forgeFetch(`api/tags/structural/getAllManualStructural?assetId=${assetId}`, (structural) => {
			structural ??= [];
			let tags = structural.map(o => Object.assign(new ForgeStructural(), o));
			tags.forEach(o => o.parseContent());
			resolve(tags);
		})
	});
}

export function fetchAssetAnnotations(assetId, userId) {
	return new Promise((resolve, reject) => {
		forgeFetch(`api/annotations/getAllAssetAnnotation?assetId=${assetId}&userId=${userId}`, (annotations) => {
			annotations ??= [];
			let result = annotations.map(o => Object.assign(new ForgeAnnotation(), o));
			result.forEach(o => o.parseContent());
			resolve(result);
		})
	});
}

export function fetchAssetScaffold(assetId) {
	return new Promise((resolve, reject) => {
		forgeFetch(`api/scaffolds/getAllAssetScaffolds?assetId=${assetId}`, (data) => {
			data ??= [];
			let scaffolds = data.map(o => Object.assign(new ForgeScaffold(), o));
			scaffolds.forEach(o => {
				//TODO: remove this later
				if (!o.type)
					o.type = 'scaffold';

				o.position = Object.assign(new THREE.Vector3(), o.position);
				o.scale = Object.assign(new THREE.Vector3(), o.scale);
				o.max = Object.assign(new THREE.Vector3(), o.max);
				o.attachments = ForgeAttachment.parseAttachments(o.attachments);
				o.parseComments();
			})
			resolve(scaffolds);
		})
	});
}

export function fetchAssetInspections(assetId) {
	return new Promise((resolve, reject) => {
		forgeFetch(`api/forge/inspections/getAllAssetInspections?assetId=${assetId}`, (data) => {
			data ??= [];
			let inspections = data.map(o => Object.assign(new ForgeInspection(), o));
			inspections.forEach(o => o.parseContent());
			store.state.forgeService.updateAMISTagsColors(inspections);
			resolve(inspections);
		})
	});
}

export function fetchUserById(userId) {
	return new Promise((resolve, reject) => {
		if (userId == null) return resolve(null);

		var url = `api/User/${encodeURIComponent(userId)}`;
		forgeFetch(url, (data) => {
			resolve(data ?? null);
		});
	});
}
